<template>
    <v-dialog v-model="mostrar" persistent max-width="70vw" scrollable>
		<v-card max-height="600px" :loading="loading">
            <template slot="progress">
                <v-progress-linear color="primary" indeterminate></v-progress-linear>
            </template>
			<v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
			<v-divider></v-divider>
            <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="12">
                        <h2 class="text-center">Você está excluindo o perfil "{{perfil.nome}}"</h2>
                        <h3 class="text-center">Confirma a exclusão?</h3>
                    </v-col>
                </v-row>
            </v-container>
            </v-card-text>
            <v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.stop="confirmar()">Confirmar</v-btn>
				<v-btn text color="primary" @click.stop="fechar()">Cancelar</v-btn>
			</v-card-actions>
		</v-card>
    </v-dialog>    
</template>

<script>
import { baseApiUrl, showError, showSuccess } from "@/config/global"
import axios from 'axios'


export default {
    name: 'Aviso',
    props:['perfil', 'mostrar'],
    data(){
        return{
            loading: false,
            cor: 'primary',
        }
    },

    methods:{
        confirmar(){
            this.loading = true
            const url = `${baseApiUrl}/Cadastros/perfis/delete.php`

                axios.post(url, {id: this.perfil.id_perfil})
                    .then(res => {
                        if(res.data.codigo == '01'){
                            showSuccess(res.data.mensagem)
                            this.$emit('atualizaPerfis', this.perfil.id_perfil)
                            this.fechar()
                        }else{
                            showError(res.data.mensagem)
                        }
                        this.loading = false
					})
            },
            
            fechar(){
                this.$emit('fechar')
            }
        },

        
}
</script>

<style scoped>

</style>